import useBannerData from "hook/useBannerData";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const AUTO_SLIDE_MS = 4500;

const Banner = () => {
  const { banners, loadingBanner } = useBannerData();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isPaused || banners.length <= 1) return undefined;

    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % banners.length);
    }, AUTO_SLIDE_MS);

    return () => clearInterval(timer);
  }, [isPaused]);

  const goToPrev = () => {
    setActiveIndex((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const goToNext = () => {
    setActiveIndex((prev) => (prev + 1) % banners.length);
  };

  if (loadingBanner) {
    return (
      <div className="relative md:max-w-7xl mx-auto px-4 sm:px-4 2xl:px-0 lg:px-8 pt-4 md:pb-4 pb-0">
        <div className="w-full h-[150px] sm:h-[220px] md:h-[300px] lg:h-[400px] rounded-md overflow-hidden relative bg-gray-300">
          {/* Shimmer gradient animation */}
          <div
            className="absolute inset-0 bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300 
                        animate-shimmer bg-[length:200%_100%]"
          />
        </div>
      </div>
    );
  }

  if (!banners || banners.length === 0) {
    return null;
  }
  return (
    <section
      className="relative overflow-hidden shadow-xl cursor-default"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
      >
        {banners.map((banner) => (
          <Link
            key={banner.id}
            to={banner.link}
            className="relative h-[150px] w-full flex-shrink-0 text-left sm:h-[280px] lg:h-[360px]"
          >
            <img
              src={`https://backend.nuhababy.com/${banner.image_path}`}
              alt={banner.title}
              className="h-full w-full object-fit"
            />
          </Link>
        ))}
      </div>

      <button
        type="button"
        onClick={goToPrev}
        aria-label="Previous slide"
        className="absolute left-3 top-1/2 -translate-y-1/2 rounded-full bg-white/85 p-2 text-slate-800 shadow-md transition hover:bg-white"
      >
        <FaChevronLeft />
      </button>

      <button
        type="button"
        onClick={goToNext}
        aria-label="Next slide"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full bg-white/85 p-2 text-slate-800 shadow-md transition hover:bg-white"
      >
        <FaChevronRight />
      </button>

      <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2">
        {banners.map((banner, index) => (
          <button
            key={banner.id}
            type="button"
            onClick={() => setActiveIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
            className={`h-2.5 rounded-full transition ${
              index === activeIndex
                ? "w-7 bg-white"
                : "w-2.5 bg-white/60 hover:bg-white/90"
            }`}
          />
        ))}
      </div>
    </section>
  );
};
export default Banner;
